import { render, staticRenderFns } from "./SchemaContentShape.vue?vue&type=template&id=dc73ad9a&scoped=true"
import script from "./SchemaContentShape.vue?vue&type=script&lang=js"
export * from "./SchemaContentShape.vue?vue&type=script&lang=js"
import style0 from "./SchemaContentShape.vue?vue&type=style&index=0&id=dc73ad9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc73ad9a",
  null
  
)

export default component.exports